import React, { useEffect } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import Header from '../Header';
import Footer from '../Footer';
import '../../styles/CommonStyles.css';

// Shown after a listing is published, either free (listing fee 0) or after a verified payment.
// AddProfessionalListing navigates here with { state: { message } }.
function ProfessionalListingSuccess() {
  const location = useLocation();
  const navigate = useNavigate();
  const message = location.state?.message;

  useEffect(() => {
    // Opened directly (no state from the form): there is nothing to confirm
    if (!message) {
      navigate('/professionals', { replace: true });
      return;
    }

    window.scrollTo(0, 0);
  }, [message, navigate]);

  if (!message) {
    return null; // Return null while redirecting
  }

  return (
    <div className="page-container">
      <Header />

      <div className="page-header">
        <h1>LISTING SUBMITTED SUCCESSFULLY</h1>
        <p>Thank you for submitting your professional listing</p>
      </div>

      <section className="content-section">
        <div className="success-container" style={{
          maxWidth: '800px',
          margin: '0 auto',
          padding: '2rem',
          backgroundColor: 'white',
          borderRadius: '8px',
          boxShadow: 'var(--box-shadow)'
        }}>
          <div style={{
            backgroundColor: '#d4edda',
            color: '#155724',
            padding: '1rem',
            borderRadius: '4px',
            marginBottom: '2rem',
            textAlign: 'center'
          }}>
            <h2 style={{ color: '#155724', marginBottom: '0.5rem' }}>Thank You!</h2>
            <p style={{ fontSize: '1.1rem' }}>{message}</p>
          </div>

          <div style={{ marginTop: '2rem', textAlign: 'center' }}>
            <p>
              If you have any questions, please contact us at <a href="mailto:info@bangalorevaluers.org">info@bangalorevaluers.org</a>
            </p>
            <Link to="/professionals" className="btn btn-light" style={{ marginTop: '1rem' }}>
              Return to Professionals Directory
            </Link>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}

export default ProfessionalListingSuccess;
